import {createAction} from 'redux-actions';

import {Animation, Environment, Index, Product, Settings} from '../general/actions';
import {dateChange, stopAnimation} from '../general/actionCreators';

/**
 * @param {Boolean} showMatrix
 */
export const showMatrix = createAction(Settings.showMatrix);

/**
 * @param {Number} product
 */
const changeProductAction = createAction(Product.change);

/**
 * @param {Number} id
 */
export const changeProduct = id => (dispatch, getState) => {
    const {productID, showProductLegend} = getState();

    if (id === productID) return;

    dispatch(changeProductAction(id));

    if (showProductLegend) dispatch(hideProductLegend);
};

export const changeIndex = createAction(Index.change);

export const changeImage = ({productID = null, index = null, offset = null}) => (dispatch, getState) => {
    const currentState = getState();

    if (index === null || index === currentState.index) {} else dispatch(changeIndex(index));
    if (offset === null || offset === currentState.offset) {} else dispatch(dateChange(offset));
    if (productID === null || productID === currentState.productID) {} else dispatch(changeProduct(productID));
};

export const panel = createAction(Animation.panel);

export const togglePanel = (dispatch, getState) => {
    const {isAnimating, panelOpen} = getState();

    dispatch(panel(!panelOpen));

    if (isAnimating) dispatch(stopAnimation());
};

const dragging = createAction(Environment.dragging);

export const startDragging = id => dragging(id);

export const endDragging = () => dragging(null);

const productLegend = createAction(Product.legend);

export const showProductLegend = productLegend(true);

export const hideProductLegend = productLegend(false);

/**
 * @param {Boolean} value
 */
export const canPreload = createAction(Environment.canPreload);
